import { colors } from './colors.js';

const typography = {
  fonts: {
    body: 'Helvetica Neue, Helvetica, Arial, system-ui, sans-serif',
    heading: 'Gill Sans, Gill Sans MT, Calibri, sans-serif;',
    monospace: 'Menlo, monospace'
  },
  rtlFonts: {
    body: 'Almarai, system-ui, sans-serif',
    heading: 'CairoBlack, sans-serif'
  },
  fontWeights: {
    body: 400,
    heading: 700
  },
  fontSizes: {
    xxsmall: '1.2rem',
    xsmall: '1.4rem',
    small: '1.6rem',
    standard: '1.8rem',
    large: '2rem',
    xlarge: '2.2rem',
    xxlarge: '2.4rem'
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125
  },
  rtlLineHeights: {
    body: 1.8,
    heading: 1.4
  },
  textShadows: {
    default: "1px 1px 0 ".concat(colors.opacities.invertedSubtle),
    // Used to help increase contrast against the palette colors
    light: "1px 1px 0 ".concat(colors.opacities.subtle)
  }
};

export { typography };
